<script setup>
import { computed } from 'vue';

const props = defineProps({
  text: { type: String, required: true },
  tag: { type: String, default: 'span' },
});

const branded = computed(() =>
  props.text.replace(
    /brain/gi,
    '<span class="brain-wordmark">br<span class="brain-highlight">ai</span>n</span>'
  )
);
</script>

<template>
  <component :is="tag" v-html="branded" />
</template>
